function capture(eventName, properties = {}) {
  if (typeof window === "undefined" || !window.posthog?.capture) return;

  window.posthog.capture(eventName, properties);
}

export function trackDashboardCta(location) {
  capture("dashboard_cta_clicked", {
    location,
    destination: "#dashboard",
  });
}

export function trackPricingCta(location) {
  capture("pricing_cta_clicked", {
    location,
    destination: "#pricing",
  });
}

export function trackBetaApplication(location) {
  capture("beta_application_clicked", {
    location,
    destination: "tidycal",
    offer: "five_customer_beta",
    price_usd: 999,
  });
}

export function trackQuestionCta(location) {
  capture("question_cta_clicked", {
    location,
    destination: "tidycal",
  });
}
